const MBI_LETTER = 'AC-HJ-KM-NP-RT-Y';
const MBI_LETTER_OR_DIGIT = `0-9${MBI_LETTER}`;

export const MBI_PATTERN_SOURCE =
  `^[1-9][${MBI_LETTER}][${MBI_LETTER_OR_DIGIT}][0-9][${MBI_LETTER}]` +
  `[${MBI_LETTER_OR_DIGIT}][0-9][${MBI_LETTER}][${MBI_LETTER}][0-9][0-9]$`;

const MBI_PATTERN = new RegExp(MBI_PATTERN_SOURCE);

export const MBI_LENGTH = 11;

export const normalizeMbi = (value: unknown): string =>
  typeof value === 'string' ? value.replace(/[^A-Za-z0-9]/g, '').toUpperCase() : '';

export const mbiIsValid = (value: unknown): boolean => MBI_PATTERN.test(normalizeMbi(value));
